import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { KeyRound } from "lucide-react";
import Header from "../../components/Header";
import { Button } from "../../components/ui/Button";
import { Input } from "../../components/ui/Input";
import { Label } from "../../components/ui/Label";
import { useAdminAuth } from "../../hooks/useAdminAuth";

export const AdminLoginPage: React.FC = () => {
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token.trim()) return;
    setIsLoading(true);
    setError(null);
    const ok = await login(token.trim());
    setIsLoading(false);
    if (ok) {
      const redirectTo =
        (location.state as { from?: string } | null)?.from || "/admin/releases";
      navigate(redirectTo, { replace: true });
    } else {
      setError("Token inválido.");
    }
  };

  return (
    <div className="min-h-screen flex flex-col text-foreground">
      <Header showActions={false} />
      <main className="flex-1 flex items-center justify-center px-5 py-16">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-sm space-y-5 bg-card border border-border rounded-lg p-7"
        >
          <div>
            <h1 className="text-lg font-semibold tracking-tight text-foreground">
              Acesso administrativo
            </h1>
            <p className="text-sm text-muted-foreground mt-1">
              Insira o token configurado em <code className="text-xs">ADMIN_AUTH_TOKEN</code>.
            </p>
          </div>

          <div className="space-y-1.5">
            <Label htmlFor="admin-token">Token</Label>
            <div className="relative">
              <KeyRound
                className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground"
                aria-hidden="true"
              />
              <Input
                id="admin-token"
                type="password"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="••••••••••••"
                autoComplete="current-password"
                autoFocus
                className="pl-10"
              />
            </div>
            {error && (
              <p className="text-xs text-destructive" role="alert">
                {error}
              </p>
            )}
          </div>

          <Button type="submit" className="w-full" disabled={isLoading || !token.trim()}>
            {isLoading ? "Verificando…" : "Entrar"}
          </Button>
        </form>
      </main>
    </div>
  );
};
